import {
  BarChart3,
  ClipboardList,
  Hourglass,
  LayoutDashboard,
  Mail,
  PackagePlus,
  Users,
  Wallet,
} from 'lucide-react';
import type { DetailsTabMenuLink } from '@/components/details';

/**
 * Zakładki ekranu wyjazdu. Segment ścieżki jest angielski jak każdy adres
 * w aplikacji, etykieta polska.
 *
 * Wyjazd ma własne wyliczenie, choć uczestnik i klient mają podobne — zestawy
 * mogą się rozjechać, a wspólny enum po cichu by tego zabronił.
 */
export enum TourTab {
  SUMMARY = 'summary',
  PARTICIPANTS = 'participants',
  CLIENTS = 'clients',
  WAITLIST = 'waitlist',
  FINANCES = 'finances',
  OPTIONS = 'options',
  STATS = 'stats',
  MESSAGES = 'messages',
}

/**
 * Zakładki wyjazdu w jednym miejscu: etykieta, znak i podpis na kaflu stoją
 * przy literale ścieżki. Osiem literałów zamiast sklejenia segmentu
 * z wyliczenia — każdy sprawdza się przy kompilacji o drzewo tras.
 */
export const tourTabLinks = (tourId: string): DetailsTabMenuLink[] => [
  {
    label: 'Podsumowanie',
    icon: LayoutDashboard,
    hint: 'Stan i kluczowe liczby',
    to: '/app/tours/$tourId/summary',
    params: { tourId },
  },
  {
    label: 'Uczestnicy',
    icon: Users,
    hint: 'Kto jedzie',
    to: '/app/tours/$tourId/participants',
    params: { tourId },
  },
  {
    label: 'Zapisujący',
    icon: ClipboardList,
    hint: 'Kto zapisał i płaci',
    to: '/app/tours/$tourId/clients',
    params: { tourId },
  },
  {
    label: 'Lista rezerwowa',
    icon: Hourglass,
    hint: 'Kto czeka na miejsce',
    to: '/app/tours/$tourId/waitlist',
    params: { tourId },
  },
  {
    label: 'Finanse',
    icon: Wallet,
    hint: 'Wpłaty i budżet',
    to: '/app/tours/$tourId/finances',
    params: { tourId },
  },
  {
    label: 'Opcje dodatkowe',
    icon: PackagePlus,
    hint: 'Dodatki do wyjazdu',
    to: '/app/tours/$tourId/options',
    params: { tourId },
  },
  {
    label: 'Statystyki',
    icon: BarChart3,
    hint: 'Zapisy w czasie',
    to: '/app/tours/$tourId/stats',
    params: { tourId },
  },
  {
    label: 'Wiadomości',
    icon: Mail,
    hint: 'Co poszło do uczestników',
    to: '/app/tours/$tourId/messages',
    params: { tourId },
  },
];
